import React, { lazy } from 'react'
import { Switch } from 'react-router-dom'

import AuthLayout from 'Layouts/auth'
import CustomRoute from 'Components/route/customRoute'
import PublicRoute from 'Components/route/publicRoute'

const RegisterFreePlanScreen = lazy(() => import('./free-plan'))
const RegisterTeamPlanScreen = lazy(() => import('./team-plan'))
const EnterpriseRegisterScreen = lazy(() => import('./enterprise-plan/register'))
const Verified = lazy(() => import('./shared/verified'))
const SignUp = lazy(() => import('./step-sign-up'))
const ContactScreen = lazy(() => import('./enterprise-plan/contact'))
const ContactScreenSuccess = lazy(() => import('./enterprise-plan/contactSuccess'))

export const RoutesName = {
  REGISTER_INDEX: '/register',
  REGISTER_FREE_PLAN_INDEX: '/register/free-plan',
  REGISTER_FREE_PLAN_VERIFIED: '/register/verified',
  REGISTER_TEAM_PLAN_INDEX: '/register/team-plan',
  REGISTER_TEAM_PLAN_VERIFIED: '/register/team-plan/verified',
  ENTERPRISE_CONTACT: '/register/:type/contact',
  ENTERPRISE_CONTACT_SUCCESS: '/register/:type/contact/success',
  ENTERPRISE_REGISTER: '/register/enterprise-plan'
}

const ROUTES = [
  {
    path: RoutesName.REGISTER_INDEX,
    layout: AuthLayout,
    component: SignUp,
    rules: []
  },
  {
    path: RoutesName.REGISTER_FREE_PLAN_INDEX,
    layout: AuthLayout,
    component: RegisterFreePlanScreen,
    rules: []
  },
  {
    path: RoutesName.REGISTER_FREE_PLAN_VERIFIED,
    layout: AuthLayout,
    component: Verified,
    verifiedMessage: 'thankYouSignUpFreePlanMessage'
  },
  {
    path: RoutesName.REGISTER_TEAM_PLAN_INDEX,
    layout: AuthLayout,
    component: RegisterTeamPlanScreen,
    rules: []
  },
  {
    path: RoutesName.REGISTER_TEAM_PLAN_VERIFIED,
    layout: AuthLayout,
    component: Verified,
    rules: [],
    verifiedTitle: 'payment.title',
    verifiedMessage: 'thankYouSignUpTeamPlanMessage'
  },
  {
    path: RoutesName.ENTERPRISE_REGISTER,
    layout: AuthLayout,
    component: EnterpriseRegisterScreen,
    rules: []
  },
  {
    path: RoutesName.ENTERPRISE_CONTACT,
    isCustom: true,
    layout: AuthLayout,
    component: ContactScreen,
    rules: []
  },
  {
    path: RoutesName.ENTERPRISE_CONTACT_SUCCESS,
    isCustom: true,
    layout: AuthLayout,
    component: ContactScreenSuccess,
    rules: []
  }
]

export default function RegisterRoutes() {
  return (
    <Switch>
      {ROUTES.map((routeConfig, index) => {
        if (routeConfig.isCustom) {
          return <CustomRoute key={index} exact {...routeConfig} />
        }

        return <PublicRoute key={index} exact {...routeConfig} />
      })}
    </Switch>
  )
}
